/* globals INITIAL_STATE */
import * as ActionTypes from '../actions/RefinePurchaseActions';
import * as InitializePurchaseActionTypes from '../actions/InitializePurchaseActions';
import * as SocialPayActionTypes from '../actions/SocialPayActions';
import deepmerge from 'deepmerge';
import { objectWithout } from 'config/utils';
import { mapPayloadForClient } from '../utils/InitializePurchaseUtils';
import { getInitialStateTotalAmount } from '../utils/GlobalUtils';
import {
  getShippingAddressFields,
  customFieldsNormalizer,
  customFormFields,
} from './refine/customFields';

function getRequiredCustomFields (customFields) {
  return Object.keys(customFields).filter(f => customFields[f].required);
}

function checkIfRequiredFieldsFilled (state) {
  if (!state.offer) {
    return false;
  }

  const { form: { customFields: customFieldsForm }, offer: { customFields } } = state;
  return getRequiredCustomFields(customFields).every(f => customFieldsForm[f].length);
}

function refinePurchase (state = getInitialState(INITIAL_STATE), action) {
  switch (action.type) {
    case ActionTypes.HANDLE_CHANGE_RP_INPUT: {
      const { payload: { changedData } } = action;
      const mergePayload = {
        ...state,
        form: {
          ...state.form,
          customFields: {
            ...state.form.customFields,
            ...changedData,
          },
          errors: objectWithout(state.form.errors, Object.keys(changedData)[0]),
        },
      };

      return {
        ...mergePayload,
        isFormValidated: checkIfRequiredFieldsFilled(deepmerge(state, mergePayload)),
      };
    }

    case ActionTypes.STORE_INITIAL_PAYLOAD: {
      const { payload: { initialPayload } } = action;
      return {
        ...state,
        initialPayload,
      };
    }

    case ActionTypes.HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE: {
      const { errors } = action;
      return {
        ...state,
        form: {
          ...state.form,
          errors,
        },
      };
    }

    case ActionTypes.HANDLE_SUBMIT_REFINE_PURCHASE_SUCCESS: {
      const { claimUri, socialpayUri } = action.response.details;
      return deepmerge(state, {
        form: {
          claimUrl: claimUri,
          socialpayUrl: socialpayUri,
        },
        isFormServerValidated: true,
      });
    }

    case SocialPayActionTypes.HANDLE_SET_SOCIAL_PAY_PLATFORM: {
      const { platform } = action.payload;
      return {
        ...state,
        form: {
          ...state.form,
          selectedSocialPayPlatform: platform,
        },
      };
    }

    case InitializePurchaseActionTypes.HANDLE_SET_TOTAL_AMOUNT: {
      const { totalAmount } = action.payload;
      return {
        ...state,
        totalAmount,
      };
    }

    case InitializePurchaseActionTypes.HANDLE_FETCH_SHIPPING_CHARGES_SUCCESS: {
      const { shippingCharges } = action.response;
      return {
        ...state,
        totalAmountWithShipping: parseFloat(state.totalAmount) + parseFloat(shippingCharges || 0),
      };
    }

    default:
      return {
        ...state,
        isFormValidated: checkIfRequiredFieldsFilled(state),
      };
  }
}

export default refinePurchase;

const getInitialState = (state) => {
  if (!state.offer) {
    return {};
  }

  let {
    shipping_address: hasShippingAddress,
    custom_fields: rawCustomFields,
    socialpay_platforms: socialpayPlatforms,
    physical: {
      states,
    } = {},
    prefilled,
  } = state.offer;

  const prefilledProps = mapPayloadForClient(prefilled);

  // TODO normalize this usage for both Initialize and Refine as it's NOT DRY.
  const notCustomFieldProps = ['name', 'email', 'phone', 'amount'];
  const prefilledCustomFields = Object.keys(prefilledProps)
    .filter(prefilledProp => notCustomFieldProps.indexOf(prefilledProp) === -1)
    .reduce((o, p) => {
      if (!prefilledProps[p].hidden) {
        o[p] = prefilledProps[p];
      }
      return o;
    }, {});

  rawCustomFields = rawCustomFields || [];

  if (hasShippingAddress) {
    // Add Custom Fields for Shipping Address manually
    rawCustomFields = [
      ...getShippingAddressFields(states),
      ...rawCustomFields,
    ];
  }

  const readOnlyProps = (fields = rawCustomFields) =>
    fields.reduce((props, field) => {
      if (prefilledCustomFields[field.name]) {
        props[field.name] = prefilledCustomFields[field.name].readonly;
      }
      return props;
    }, {});

  return {
    totalAmount: getInitialStateTotalAmount(),
    totalAmountWithShipping: 0,
    offer: {
      hasShippingAddress,
      customFields: customFieldsNormalizer(rawCustomFields),
      socialpayPlatforms,
    },
    form: {
      errors: {},
      claimUrl: null,
      customFields: customFormFields({
        fields: rawCustomFields, prefilledCustomFields,
      }),
      readOnly: readOnlyProps(),
      selectedSocialPayPlatform: null,
    },
    isFormValidated: false,
    isFormServerValidated: false,
    initialPayload: {},
  };
};



// WEBPACK FOOTER //
// ./src/payments/reducers/RefinePurchaseReducers.js